export const getDistinctItems = <T>(array: T[]): T[] => {
    return [...new Set(array)];
};
